import { type RouteRecordRaw } from 'vue-router'

export const invitationRoutes: RouteRecordRaw[] = [
  {
    path: '/invitation',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: ':type',
        name: 'invitation-status',
        component: () =>
          import('pages/receiver/invitations/InvitationStatus.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'fail/:type',
        name: 'email-invitation-fail',
        component: () =>
          import('pages/receiver/invitations/EmailInvitationFail.vue'),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: 'success',
        name: 'invitation-success',
        component: () =>
          import('pages/receiver/invitations/InvitationWelcome.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
